import { useQuery } from "@tanstack/react-query";

import { GraphQLAPI, GraphQLResult, queries } from "@examspark/api";
import { WebDocument } from "@examspark/types";

const getWebDocument = (id?: string, sk = "resource#v0") => ({
  queryKey: ["web-document", id, sk],
  enabled: !!id && !!sk,
  queryFn: async () => {
    const result = (
      (await GraphQLAPI.query({
        query: queries.media.getWebDocument({
          fields: `
              id
              sk
              name
              workspaceId
              bankId
              createdAt
              updatedAt
              content {
                body
              }
              resources {
                id
                sk
                data
                resource {
                  id
                  sk
                  name
                  type
                  file {
                    bucket
                    region
                    key
                  }
                }
                tags {
                  key
                  type
                  value
                }
              }
            `,
        }),
        variables: {
          input: {
            id: id,
            sk: sk,
          },
        },
      })) as GraphQLResult<{ getWebDocument: WebDocument }>
    ).data?.getWebDocument;

    return result;
  },
});

export const useQueryGetWebDocument = (id?: string, sk?: string) => {
  return useQuery(getWebDocument(id, sk));
};
